// Module
var code = "<div class=\"form-control-static\"> {{::displayValue}} </div>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/readonly/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;